import { Navigate } from '@sorare/routing';

import {
  So5FixtureEvent,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { ANY_SPORT_MY_CIRCLES_EVENTTYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useLastVisitedEventType } from 'hooks/useLastVisitedEventType';

const MyCirclePage = () => {
  const { lastVisitedEventType } = useLastVisitedEventType();
  const { sport, generateSportContextPath } = useSportContext();
  const defaultEventType =
    (sport !== Sport.FOOTBALL && lastVisitedEventType) ||
    So5FixtureEvent.CLASSIC;

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_MY_CIRCLES_EVENTTYPE, {
        params: {
          eventType: defaultEventType,
        },
      })}
      replace
    />
  );
};

export default MyCirclePage;
